/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Components
 */
import RangeInput from '../../../../common/RangeInput/RangeInput'
import { symbol } from '../../../../common/CurrencyFormat'

/**
 * Will return the value of the input or the value of the label
 *
 * @param {any} value
 * @returns {number} the value to use
 */
const returnValue = (value, props) => {
    switch (value) {
        case 0:
            return props.minExcession
        case 1:
            return (250 * props.excessionDefault)
        case 2:
            return (500 * props.excessionDefault)
        case 3:
            return (1000 * props.excessionDefault)
        case 4:
            return props.maxExcession
        case props.minExcession:
            return 0
        case (250 * props.excessionDefault):
            return 1
        case (500 * props.excessionDefault):
            return 2
        case (1000 * props.excessionDefault):
            return 3
        case props.maxExcession:
            return 4
        default:
            return

    }
}

/**
 * Will generate the measurements lines in the layour
 *
 * @param {any} N
 * @returns {ReactDOM}
 */
const generateMeasurements = (N) => {
    let array = Array.apply(null, { length: N }).map(Number.call, Number)
    return array.map((item) => {
        return (
            <div className={`measurements collectors measurements-excess-${item + 1}`} key={item} />
        )
    })
}

const RateVariationExcess = (props: any) => (
    <div className="adjustment">
        <div className="adjustment__title">Excess:</div>
        <div className="adjustment__range">
            {generateMeasurements(5)}
            <RangeInput
                onChange={(value) => { props.onChange(returnValue(value, props)) }}
                value={returnValue(props.value, props)}
                max={4}
                min={0}
            />
        </div>
        <div className="adjustment__result">{symbol()} {props.value}</div>
    </div>
)

export default RateVariationExcess



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step05c/components/RateVariationExcess.tsx